import { fromJS } from 'immutable';
import { isVortexPage } from '../utils/vortexAllowList';
import { moduleName } from '../constants';

const IS_VORTEX = `${moduleName}/IS_VORTEX`;
const IS_VORTEX_ENABLED = `${moduleName}/IS_VORTEX_ENABLED`;
const IS_DLS7_ENABLED = `${moduleName}/IS_DLS7_ENABLED`;
const IS_DLS7_ELIGIBLE = `${moduleName}/IS_DLS7_ELIGIBLE`;
const RAMP_UP_ELIGIBILITY = `${moduleName}/RAMP_UP_ELIGIBILITY`;

const initialState = () => fromJS({
  vortex: false,
  vortexEnabled: false,
  dls7Enabled: false,
  dls7Eligible: 'initial-state-not-eligible',
  rampUp: {
    isEligible: false,
    reason: 'initial-state-not-eligible',
  },
});

const reducer = (state = initialState(), action = {}) => {
  switch (action.type) {
    case IS_VORTEX:
      return state.set('vortex', isVortexPage(action.value));
    case IS_VORTEX_ENABLED:
      return state.set('vortexEnabled', action.value);
    case IS_DLS7_ENABLED:
      return state.set('dls7Enabled', action.value);
    case IS_DLS7_ELIGIBLE:
      return state.set('dls7Eligible', action.value);
    case RAMP_UP_ELIGIBILITY:
      return state.set('rampUp', action.value);
    default:
      return state;
  }
};

const setVortex = (value) => ({
  type: IS_VORTEX,
  value,
});

const setVortexEnabled = (value) => ({
  type: IS_VORTEX_ENABLED,
  value,
});

const setRampUpEligibility = (value) => ({
  type: RAMP_UP_ELIGIBILITY,
  value,
});

const setIsDls7Enabled = (value) => ({
  type: IS_DLS7_ENABLED,
  value,
});

const setIsDls7Eligible = (value) => ({
  type: IS_DLS7_ELIGIBLE,
  value,
});

export default reducer;

export {
  IS_VORTEX,
  IS_VORTEX_ENABLED,
  IS_DLS7_ENABLED,
  IS_DLS7_ELIGIBLE,
  RAMP_UP_ELIGIBILITY,
  setVortex,
  setVortexEnabled,
  setRampUpEligibility,
  setIsDls7Enabled,
  setIsDls7Eligible,
};
